import { render, staticRenderFns } from "./telSuccess.vue?vue&type=template&id=5b3041a3&scoped=true"
import script from "./telSuccess.vue?vue&type=script&lang=js"
export * from "./telSuccess.vue?vue&type=script&lang=js"
import style0 from "./telSuccess.vue?vue&type=style&index=0&id=5b3041a3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3041a3",
  null
  
)

export default component.exports